import axios from 'axios';
import { getUserFromLS } from '../../utils/getUserFromLS';
import { ICalendarIndustryInsight } from '../../Types/calendar';

export const getIndustryInsight = (
  insightId: string,
  callback: (response: ICalendarIndustryInsight) => void,
  errorCallback: (error: any) => void
) => {
  const user = getUserFromLS();
  const URL = `${import.meta.env.VITE_API_BASE_URL}/industry_insights/${insightId}`;

  return axios(URL, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${user.access_token}`
    }
  })
    .then((response) => {
      if (callback != null) {
        callback(response.data as ICalendarIndustryInsight);
      }
    })
    .catch((error) => {
      console.error('Error fetching industry insight:', error);
      if (errorCallback != null) {
        errorCallback(error);
      }
    });
};
